export const APP_STORE_URL =
  process.env.REACT_APP_APP_STORE_URL ||
  "https://apps.apple.com/us/app/ateno-ai-room-designer/id6759706148";

export const GOOGLE_PLAY_URL =
  process.env.REACT_APP_GOOGLE_PLAY_URL ||
  "https://play.google.com/store/apps/details?id=com.ateno.app";

export const STORE_LINKS = [
  {
    key: "apple",
    label: "App Store",
    href: APP_STORE_URL,
    to: APP_STORE_URL,
    logo: "/assets/logos/store/apple.svg",
  },
  {
    key: "google",
    label: "Google Play",
    href: GOOGLE_PLAY_URL,
    to: GOOGLE_PLAY_URL,
    logo: "/assets/logos/store/google_play.png",
  },
];
